import React from 'react';

const Shop = () => {
  return <div>MOIN!</div>;
};

export default Shop;
